<template>
    <v-container id="emergency-contact" fluid>
        <v-card-subtitle class="px-0">
            <v-icon :color="kingsGold" left>mdi-account-box</v-icon>Basic Information
        </v-card-subtitle>
        <v-row>
            <v-col cols="12" md="4">
                <v-select v-model="item.parentGuardianEmergencyContact.title" dense :items="titleItems" label="Title"
                    outlined placeholder="Please select..." required :rules="titleRules">
                </v-select>
            </v-col>
            <v-col cols="12" md="8">
                <v-text-field v-model="item.parentGuardianEmergencyContact.fullName" dense label="Full Name" outlined
                    :rules="fullNameRules" required>
                </v-text-field>
            </v-col>
            <v-col cols="12">
                <v-text-field v-model="item.parentGuardianEmergencyContact.relationship" dense label="Relationship"
                    outlined :rules="relationshipRules" required>
                </v-text-field>
            </v-col>
        </v-row>
        <v-card-subtitle class="px-0">
            <v-icon :color="kingsGold" left>mdi-home</v-icon> Address Information
        </v-card-subtitle>
        <v-row>
            <v-col cols="12" md="8">
                <v-text-field v-model="item.parentGuardianEmergencyContact.address" dense label="Home Address" outlined
                    :rules="addressRules" required>
                </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
                <v-text-field v-model="item.parentGuardianEmergencyContact.postalCode" dense label="Postal Code"
                    outlined :rules="postalCodeRules" required>
                </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
                <v-text-field v-model="item.parentGuardianEmergencyContact.country" dense label="Country" outlined
                    :rules="countryRules" required>
                </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
                <v-text-field v-model="item.parentGuardianEmergencyContact.city" dense label="City" outlined
                    :rules="cityRules" required>
                </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
                <v-select v-model="item.parentGuardianEmergencyContact.province" dense :items="provinceItems"
                    label="Province" outlined placeholder="Please select..." :rules="provinceRules" required>
                </v-select>
            </v-col>
            <v-col v-if="item.parentGuardianEmergencyContact.province == 'Other'" cols="12">
                <v-text-field v-model="item.parentGuardianEmergencyContact.provinceOther" dense label="Province (Other)"
                    outlined :rules="provinceOtherRules" required>
                </v-text-field>
            </v-col>
        </v-row>
        <v-card-subtitle class="px-0">
            <v-icon :color="kingsGold" left>mdi-card-account-details</v-icon>Contact Information
        </v-card-subtitle>
        <v-row>
            <v-col cols="12" md="6">
                <v-text-field v-model="item.parentGuardianEmergencyContact.homePhone" dense label="Home Phone" outlined
                    :rules="homePhoneRules" required>
                </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
                <v-text-field v-model="item.parentGuardianEmergencyContact.cellPhone" dense label="Cell Phone" outlined
                    :rules="cellPhoneRules" required>
                </v-text-field>
            </v-col>
            <v-col cols="12">
                <v-text-field v-model="item.parentGuardianEmergencyContact.email" dense label="Email" outlined
                    :rules="emailRules" required>
                </v-text-field>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'applicant-emergency-contact',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            addressRules: [
                v => !!v || 'Home address is required',
                v => (v && v.length >= 2) || 'Please provide a valid home address',
            ],
            cellPhoneRules: [
                v => !!v || 'Cell phone is required',
            ],
            cityRules: [
                v => !!v || 'City is required',
                v => (v && v.length >= 2) || 'Please provide a valid city',
            ],
            countryRules: [
                v => !!v || 'Country is required',
                v => (v && v.length >= 2) || 'Please provide a valid country',
            ],
            emailRules: [
                v => !!v || 'Email is required',
                v => (v && v.length >= 2) || 'Please provide a valid email',
            ],
            fullNameRules: [
                v => !!v || 'Full name is required',
                v => (v && v.length >= 2) || 'Full name must be more than 2 characters',
            ],
            homePhoneRules: [
                v => !!v || 'Home phone is required',
            ],
            relationshipRules: [
                v => !!v || 'Relationship is required',
                v => (v && v.length >= 2) || 'Please provide a valid relationship',
            ],
            postalCodeRules: [
                v => !!v || 'Postal code is required',
                v => (v && v.length >= 2) || 'Please provide a valid postal code',
            ],
            provinceItems: [{
                    text: 'Alberta',
                    value: 'AB'
                },
                {
                    text: 'British Columbia',
                    value: 'BC'
                },
                {
                    text: 'Manitoba',
                    value: 'MB'
                },
                {
                    text: 'New Brunswick',
                    value: 'NB'
                },
                {
                    text: 'Newfoundland and Labrador',
                    value: 'NL'
                },
                {
                    text: 'Northwest Territories',
                    value: 'NT'
                },
                {
                    text: 'Nova Scotia',
                    value: 'NS'
                },
                {
                    text: 'Nunavut',
                    value: 'NU'
                },
                {
                    text: 'Ontario',
                    value: 'ON'
                },
                {
                    text: 'Prince Edward Island',
                    value: 'PE'
                },
                {
                    text: 'Quebec',
                    value: 'QC'
                },
                {
                    text: 'Saskatchewan',
                    value: 'SK'
                },
                {
                    text: 'Yukon',
                    value: 'YT'
                },
                {
                    text: 'Other',
                    value: 'Other'
                }
            ],
            provinceRules: [
                v => !!v || 'Province is required'
            ],
            provinceOtherRules: [
                v => !!v || 'Province (other) is required',
                v => (v && v.length >= 2) || 'Please provide a valid province (other)',
            ],
            sameAddress: false,
            titleItems: [{
                    text: 'Mr.',
                    value: 'Mr'
                },
                {
                    text: 'Mrs.',
                    value: 'Mrs'
                },
                {
                    text: 'Ms.',
                    value: 'Ms'
                },
                {
                    text: 'Dr.',
                    value: 'Dr'
                }
            ],
            titleRules: [
                v => !!v || 'Title is required'
            ],
            valid: true
        }
    },
    computed: {
        kingsGold() {
            return '#d7ae28';
        },
        successColor() {
            return '#1bc5bd';
        }
    }
}
</script>

<style scoped>
.col-12 {
    padding-bottom: 0;
    padding-top: 0;
}
</style>